var portfolioBreakdown = {
	table: {
		caption: "Portfolio Breakdown",
		name: {
			assetClass: "Asset class",
			currency: "Currency",
			sector: "Sector"
		}
	},
	chart: {
		counting: {
			assetClass: "Asset classes",
			currency: "Currencies",
			sector: "Sectors"
		},
		topPositions: {
			assetClass: "Top asset classes",
			currency: "Top currencies",
			sector: "Top sectors"
		}
	},
	assetClasses: {
		bond: "Bond",
		commodity: "Commodity",
		currency: "Currency",
		debt: "Debt",
		etf: "ETF",
		fund: "Fund",
		generic: "Generic",
		index: "Index",
		stock: "Stock",
		interestRate: "Interest Rate",
		structuredProduct: "Structured Product",
		investmentProduct: "Investment Product",
		leveragedProduct: "Leveraged Product",
		option: "Option",
		future: "Future"
	}
};
var en = {
	portfolioBreakdown: portfolioBreakdown
};

export { en as default, portfolioBreakdown };
